import HonestFarmerClub from "./HonestFarmerClub.json"
import HonestTraits from "./HonestTraits.json"
import Whitelist from "./Whitelist.json"

// V2
import MigrationTractor from "./MigrationTractor.json"
import WhitelistFarmer from "./WhitelistFarmer.json"
import HonestFarmerClubV2 from "./HonestFarmerClubV2.json"
import TheFarm from "./TheFarm.json"
import RevealFarmer from "./RevealFarmer.json"
import MetaFarmer from "./MetaFarmer.json"
import Potato from "./Potato.json"
import RewardFarmer from "./RewardFarmerV5.json"
import FarmGirls from "./FarmGirls.json"
import WheelOfFortune from "./WheelOfFortune.json"
import TheFarmV2 from "./TheFarmV2.json"

export const HonestFarmerClubABI = HonestFarmerClub.abi
export const HonestTraitsABI = HonestTraits.abi
export const WhitelistABI = Whitelist.abi

// V2
export const HonestFarmerClubV2ABI = HonestFarmerClubV2.abi
export const WhitelistFarmerABI = WhitelistFarmer.abi
export const MigrationTractorABI = MigrationTractor.abi
export const TheFarmABI = TheFarm.abi
export const RevealFarmerABI = RevealFarmer.abi
export const MetaFarmerABI = MetaFarmer.abi
export const PotatoABI = Potato.abi
export const RewardFarmerABI = RewardFarmer.abi
export const FarmGirlsABI = FarmGirls.abi
export const WheelOfFortuneABI = WheelOfFortune.abi
export const TheFarmV2ABI = TheFarmV2.abi
